import {computed, shallowRef} from 'vue'
import {defineStore} from 'pinia'
import type {fabric} from 'fabric'

// Fabric instances must not be deeply reactive (proxies break identity checks and fabric internals), hence shallowRef.
export default defineStore('boardCanvas', () => {
  const canvas = shallowRef<fabric.Canvas | null>(null)
  const selection = shallowRef<fabric.Object | null>(null)
  const ocrFields = shallowRef<fabric.Object[]>([])

  // 'rect' | 'circle' | 'i-text' | 'path' | ... | null
  const selectionType = computed(() => selection.value?.type ?? null)

  function setCanvas(value: fabric.Canvas | null) {
    canvas.value = value
  }

  function setSelection(value: fabric.Object | null) {
    selection.value = value
  }

  function addOcrField(field: fabric.Object) {
    ocrFields.value = [...ocrFields.value, field]
  }

  function clearOcrFields() {
    ocrFields.value = []
  }

  return {canvas, selection, selectionType, ocrFields, setCanvas, setSelection, addOcrField, clearOcrFields}
})
